<template>
  <div class="row">
    <div class="col-md-10 col-md-12 ">
      <div class="card">
        <div :class="(loading ? 'show-loader' : 'hide-loader')">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg><!---->
          </div>
        </div>
        <div class="card-header">
        </div>
        <div class="card-content row">
          <div class="col-sm-12">
          <!--   <div class="pull-left">
              <el-input v-model="filters[0].value" placeholder="Search" class="icon-search"></el-input>
            </div> -->
            <div class="pull-right ">
              <router-link class="btn btn-info" :to="{ path: '/marketing/offers/add'}"><i class="ti-plus"></i> {{$t('general.add')}} {{$t('marketingOffers.single')}}</router-link>
            </div>
          </div>

          <table class="table " ref="sortableTable">
            <thead>
                  <tr>
                    <th></th>
                    <th>{{$t('marketingOffers.image')}}</th>
                    <th>{{$t('marketingOffers.title')}}</th>
                    <th>{{$t('marketingOffers.linkType')}}</th> 
                    <th>{{$t('marketingOffers.startEndDate')}}</th>
                    <th>{{$t('marketingOffers.actions')}}</th>
                    <th width="30px"></th>
                  </tr>
            </thead>
            <draggable v-model="tableData" :element="'tbody'" @end="adjustSort">
              <template v-for="(item, index) in tableData">
                <tr class="sortableRow" :key="item.id" @click="goToRecord(item,[],[], $event)">
                  <td >
                    <!-- <button style="cursor: move" class="btn"><v-icon>drag_handle</v-icon></v-btn> -->
                      <i style="cursor: move" class="fa fa-arrows sortHandle"></i>
                  </td>
                  <td ><div class="cell"><img v-bind:src="(item.image)?item.image : ''" /></div></td>
                  <td>{{ item.title }}</td>
                  <td>{{ item.link_type }}</td>
                  <td> {{formatDate(item.date_start)}} - {{formatDate(item.date_end)}}</td>
                  <td>
                    <el-button  @click="handleDelete(index, item, $event)" >  {{$t('general.delete')}} </el-button>
                  </td>
                  <td><i class="fa fa-pencil"></i></td>
                </tr>
              </template>
            </draggable>
          </table>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Input, Select, Option} from 'element-ui'
  import DataTables from 'vue-data-tables'
  import draggable from 'vuedraggable'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  Vue.use(Input)
  Vue.use(Select)
  Vue.use(Option)
  Vue.use(DataTables)
  export default{
    components: {
      PPagination,
      PSwitch,
      draggable
    },
    watch: {
    },
    computed: {
    },
    data () {
      return {
        loading: true,
        actionCol: {
          label: 'Delete',
          props: {
            align: 'center'
          },
          buttons: [{
            props: {
              type: 'danger',
              icon: 'el-icon-delete',
              class: 'btn btn-orange btn-fill'
            },
            handler: (index, row) => {
              this.handleDelete(index, row)
            },
            label: 'delete'
          }]
        },
        paginationDef: {
          pageSize: 999,
          currentPage: 1,
          pageSizes: [999],
          show: false,
          disabled: true
        },
        searchQuery: '',
        propsToSearch: ['name', 'status', 'type', 'discount'],
        tableColumns: [],
        tableData: [],
        filters: [
          {
            value: '',
            prop: ['title', 'link_type', 'date_start', 'date_end']
          }
        ]
      }
    },
    created: function () {
      this.$nextTick(function () {
        this.loading = true
      })
      var self = this
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        use_sort_order: 'asc'
      }
      this.apiRequest('/banner', 'GET', data, function (response) {
        if (response.status === true) {
          self.tableData = response.data
        }
        self.$nextTick(function () {
          self.loading = false
        })
      })
    },
    methods: {
      goToRecord (row, event, column) {
        if (column.label !== 'Actions' && column.label !== 'Status') {
          this.globalGoToRecord(row, event, column, '/marketing/offers/edit/')
        }
      },
      adjustSort (evt) {
        if (this.tableData.length > 1) {
          var idx = evt.newIndex
          var after, before, sortOrder

          if (idx === 0) {
            console.warn('first')
            before = 0
            after = this.tableData[idx + 1].sort_order
          } else if ((idx + 1) === this.tableData.length) {
            console.warn('last')
            before = this.tableData[idx - 1].sort_order
            after = parseFloat(before) + 1
          } else {
            console.warn('middle')
            before = this.tableData[idx - 1].sort_order
            after = this.tableData[idx + 1].sort_order
          }

          sortOrder = (parseFloat(before) + parseFloat(after)) / 2
          var id = this.tableData[idx].id

          var data = {
            id: id,
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany'),
            sort_order: sortOrder
          }
          var self = this
          this.apiRequest('/banner/' + id, 'PUT', data, function (response) {
            if (response.status !== true) {
              swal(
                {
                  title: '',
                  text: self.$t('validations.dataCouldNotBeSaved'),
                  type: 'danger',
                  showConfirmButton: false,
                  timer: 1500
                }
              ).catch(() => {}) // end swal
            }
          })
        }
      },
      handleDelete (index, row, event) {
        var self = this
        event.stopPropagation()
        var btnCounter = 3
        swal({
          text: self.$t('marketingCampaigns.areYouSureDelete') + ` '${row.title}'?`,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: self.$t('general.yes') + ' (' + btnCounter + ')'
        })
        .then((result) => {
          if (result) {
            var data = {
              token: this.$session.get('token'),
              company_id: this.$session.get('selectedCompany')
            }
            this.apiRequest('/banner/' + row.id, 'DELETE', data, function (response) {
              if (response.status === true) {
                swal(
                  '',
                  self.$t('marketingOffers.offerDeleted'),
                  'success'
                )
                self.tableData.splice(index, 1)
              } else {
                swal(
                  '',
                  self.$t('validations.wentWrong'),
                  'error'
                )
              }
            })
          }
        }).catch(() => {
          //
        })
        swal.disableConfirmButton()
        var btnInterval = setInterval(function () {
          btnCounter--

          if (btnCounter >= 1) {
            swal.getConfirmButton().textContent = self.$t('general.yes') + '(' + btnCounter + ')'
          } else {
            clearInterval(btnInterval)
            swal.getConfirmButton().textContent = self.$t('general.yes')
            swal.enableConfirmButton()
          }
        }, 1000)
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/Offers/Offers.vue